<template>
  <div>
    <div>
      <ZykHeader
        @search="search"
        v-on:childDialogStatus="childDialogStatus(arguments)"
        v-on="$listeners"
      />
    </div>
    <div class="read-page">
      <div class="left-book">
        <img class="tip-box" src="@/assets/images/welcome/jm-tip.png" alt="" />
        <img
          class="read-book"
          src="@/assets/images/welcome/jm-logo.png"
          alt=""
        />
      </div>
      <div class="course-card">
        <div class="card-title">欢迎加入绝密资料专区</div>
        <div class="line"></div>
        <div class="tip">请选择您的年级学期</div>
        <div class="course-item">
          <span class="course-name">年级：</span>
          <div
            class="item"
            data-io-click="tracker"  @click="changeCurrentGradeIndex(index)"
            :class="{ active: index == currentGradeIndex }"
            v-for="(item, index) in gradeList"
            :key="item.id"
          >
            {{ item.name }}
          </div>
        </div>
        <div class="course-item">
          <span class="course-name">学期：</span>
          <div
            class="item"
            data-io-click="tracker"  @click="changeCurrentTermIndex(index)"
            :class="{ active: index == currentTermIndex }"
            v-for="(item, index) in termList"
            :key="item.id"
          >
            {{ item.name }}
          </div>
        </div>
        <div
          class="submit-btn"
          data-io-click="tracker"  @click="handleChooseCurrentCourse"
          :class="{
            active: currentTermIndex >= 0 && currentGradeIndex >= 0,
          }"
        >
          确定
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ZykHeader from "@/components/ZykHeader.vue";
// 文档列表，页码，当前预览在resource中
import filterMixin from "@/assets/js/mixin/filterMixin";
import tracker from "@/assets/js/statistics/xkw.tracker";
import {
  getGradeAndTermList,
  getStageSubjectList,
  getUserUsedCourse,
  updateLastUsedGradeAndTerm,
} from "@/utils/apis";
import { mapMutations, mapState } from "vuex";
const CURRENTCOURSE = "CURRENTCOURSE";
export default {
  inject: ["textbook"],
  mixins: [filterMixin],
  components: {
    ZykHeader,
  },
  data() {
    return {
      subjectList: [],
      currentGradeIndex: null,
      currentTermIndex: null,
      gradeList: [],
      termList: [],
    };
  },
  computed: {
    ...mapState(["userCourses", "currentCourse", "userInfo"]),
  },
  async mounted() {
    // await this.getStageSubjectList();
    // this.getUserUsedCourse();
  },
  watch: {
    currentStageIndex(val) {
      this.subjectList = this.userCourses[val].courseList;
    },
    currentCourse: {
      handler(val, oldVal) {
        console.log("val, oldVal---", val, oldVal);
        if (
          (val && !oldVal) ||
          (val &&
            oldVal &&
            val.stageId != oldVal.stageId &&
            val.subjectId != oldVal.subjectId)
        ) {
          this.getGradeAndTermList();
          //   let { stageId, subjectId } = val;
          //   if (val.isLastUsedCourse) {
          //     // this.$router.replace("/read/");
          //     return;
          //   }
          //   // console.log("=---val", val, this.userCourses);
          //   if (this.userCourses?.length && stageId && subjectId) {
          //     for (let i = 0; i < this.userCourses.length; i++) {
          //       let item = this.userCourses[i];
          //       if (item.id == stageId) {
          //         if (item?.courseList?.length) {
          //           let findIndex = item.courseList.findIndex(
          //             (course) => course.subjectId == subjectId
          //           );
          //           console.log("findIndex", findIndex);
          //           if (findIndex > -1) {
          //             this.currentStageIndex = i;
          //             this.currentSubjectIndex = findIndex;
          //             return;
          //           }
          //         }
          //       }
          //     }
          //   } else {
          //     // this.currentStageIndex = 0;
          //     this.subjectList = this.userCourses[0].courseList;
          //     // this.currentSubjectIndex = findIndex;
          //   }
        }
      },
      immediate: true,
    },
    userCourses: {
      handler(val) {
        if (val) {
          console.log("va-----l", val);
          if (val?.length) {
            for (let i = 0; i < val.length; i++) {
              let item = val[i];
              if (item?.courseList?.length) {
                let findIndex = item.courseList.find((course) => course.isUse);
                console.log("findIndex", findIndex);
                if (findIndex > -1) {
                  subjectList = item.courseList;
                  this.currentStageIndex = i;
                  this.currentSubjectIndex = findIndex;
                  return;
                }
              }
            }
          }
          // this.subjectList = val[0].subjectList;
        }
      },
      immediate: true,
    },
  },
  methods: {
    ...mapMutations(["setCurrentCourse", "changeHasAiUsedCourses"]),
    watchRouteChange(to, from) {},
    childDialogStatus: function (childDialogStatus) {
      this.documentInfo = childDialogStatus[0];
      this.type = childDialogStatus[1];
      tracker.handleSendTongji({
        $event_name: "no_attribute_event",
        two_level_event_name: "wxt_doc_detail_popup",
      });
    },
    async getGradeAndTermList() {
      let { result } = await getGradeAndTermList({
        stageId: this.currentCourse.stageId,
        subjectId: this.currentCourse.subjectId,
      });
      const findGradeIndex = result.gradeList.findIndex((item) => item.isUsed);
      const findTermIndex = result.termList.findIndex((item) => item.isUsed);
      // const currentGradeIndex = findGradeIndex === -1 ? 0 : findGradeIndex;
      // const currentTermIndex = findTermIndex === -1 ? 0 : findTermIndex;
      this.currentGradeIndex = findGradeIndex;
      this.currentTermIndex = findTermIndex;
      this.gradeList = result.gradeList;
      this.termList = result.termList;
      console.log("result", result);
    },
    async getUserUsedCourse() {
      let { result } = await getUserUsedCourse();
      let { stageId, subjectId } = result;
      this.stageSubjectList.forEach((stage) => {
        if (stage.id == stageId) {
          stage.subjectList.forEach((subject) => {
            if (subject.id == subjectId) {
              let currentCourse = subject.course;
              currentCourse.stageId = stage.id;
              currentCourse.stageName = stage.name;
              currentCourse.subjectId = subject.id;
              currentCourse.subjectName = subject.name;
              console.log("当前课程", currentCourse);
              this.setCurrentReadCourse(currentCourse);
            }
          });
        }
      });
    },
    async getStageSubjectList() {
      let data = await getStageSubjectList();
      this.stageSubjectList = data.result || [];
      this.subjectList = this.stageSubjectList[0].subjectList;
      // console.log("----data", data);
    },
    changeCurrentGradeIndex(index) {
      this.currentGradeIndex = index;
    },
    changeCurrentTermIndex(index) {
      this.currentTermIndex = index;
    },
    async handleChooseCurrentCourse() {
      if (this.currentGradeIndex != null && this.currentTermIndex != null) {
        let currentGradeId = this.gradeList[this.currentGradeIndex].id;
        let currentTermId = this.termList[this.currentTermIndex].id;
        // 更新绝密年级和学期
        let result = await updateLastUsedGradeAndTerm({
          gradeId: currentGradeId,
          productId: 8,
          stageId: this.currentCourse.stageId,
          subjectId: this.currentCourse.subjectId,
          term: currentTermId,
        });
        if (result.result) {
          this.$router.replace(`/zyk/juemi/`);
        }
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.read-page {
  width: 100%;
  height: calc(100vh - 78px);
  background-image: url("../../../assets/images/welcome/jm-bg.png");
  background-color: #e5f1ff;
  background-repeat: no-repeat;
  background-position: top center;
  background-size: 100% auto;
  display: flex;
  justify-content: center;
  align-items: center;
  .left-book {
    display: flex;
    flex-direction: column;
    margin-top: -88px;
    .tip-box {
      width: 314px;
      height: 159px;
    }
    .read-book {
      width: 449px;
      height: 370px;
      margin-left: -93px;
      margin-top: -4px;
    }
  }
  .course-card {
    // width: 374px;
    padding: 42px;
    height: fit-content;
    border-radius: 16px;
    border: 1px solid #fff;
    background: linear-gradient(
      138deg,
      rgba(255, 255, 255, 0.8) 0%,
      rgba(255, 255, 255, 0.5) 100%
    );
    box-shadow: 0px 12px 30px 0px rgba(30, 80, 121, 0.1);
    backdrop-filter: blur(2px);
    margin-left: 58px;
    .card-title {
      font-size: 36px;
      line-height: 1;
      color: #000;
      margin-bottom: 12px;
    }
    .line {
      width: 80px;
      height: 4px;
      background: #0057ff;
      margin-bottom: 36px;
    }
    .tip {
      font-size: 16px;
      line-height: 24px;
      color: #666666;
    }
    .course-item {
      margin-top: 24px;
      display: flex;
      align-items: center;
      .course-name {
        font-size: 14px;
        color: #666666;
        margin-right: 8px;
      }
      .item {
        padding: 0 8px;
        height: 24px;
        line-height: 24px;
        border-radius: 4px;
        font-size: 14px;
        color: #1a1a1a;
        background: #fff;
        margin-right: 12px;
        cursor: pointer;
        &:last-child {
          margin-right: 0;
        }
        &:hover {
          background: #e6f2ff;
          color: #0057ff;
        }
        &.active {
          background: #0057ff;
          color: #fff;
          &:hover {
            background: #0057ff;
          }
        }
      }
    }
    .submit-btn {
      cursor: pointer;
      text-align: center;
      margin-top: 60px;
      height: 42px;
      line-height: 42px;
      border-radius: 6px;
      font-size: 14px;
      color: #fff;
      background: #99ccff;
      &.active {
        background: #0057ff;
      }
      &:hover {
        background: #4494ff;
      }
    }
  }
}
</style>
